(() => {
  const initialise = (form) => {
    if (form.dataset.variantBoxesInitialised === 'true') return;

    const groups = [...form.querySelectorAll('[data-variant-boxes]')];
    if (!groups.length) return;
    form.dataset.variantBoxesInitialised = 'true';

    const selects = [...form.querySelectorAll('[data-product-option]')];
    const variantsNode = form.querySelector('[data-variants-json]');
    let variants = [];

    try {
      variants = JSON.parse(variantsNode?.textContent || '[]');
    } catch (error) {
      variants = [];
    }

    const render = () => {
      groups.forEach((group) => {
        const position = Number(group.dataset.optionPosition || 0);
        const select = selects[position];
        if (!select) return;

        group.querySelectorAll('[data-variant-box]').forEach((button) => {
          const value = button.dataset.optionValue;
          const selected = select.value === value;
          const availableForValue = variants.some((variant) =>
            variant.options?.[position] === value && variant.available
          );
          const unavailable = !availableForValue;
          const status = button.querySelector('[data-variant-box-status]');

          button.classList.toggle('is-selected', selected);
          button.classList.toggle('is-unavailable', unavailable);
          button.disabled = unavailable;
          button.setAttribute('aria-pressed', selected ? 'true' : 'false');
          button.setAttribute('aria-disabled', unavailable ? 'true' : 'false');
          if (status) status.textContent = unavailable ? 'Sold out' : '';
        });
      });
    };

    groups.forEach((group) => {
      const position = Number(group.dataset.optionPosition || 0);
      const select = selects[position];

      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-variant-box]');
        if (!button || button.disabled || !select) return;
        select.value = button.dataset.optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        render();
      });
    });

    selects.forEach((select) => select.addEventListener('change', render));
    form.addEventListener('variant:change', render);
    render();
  };

  const boot = () =>
    document.querySelectorAll('[data-product-form]').forEach(initialise);

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
